import React from 'react'
import css from './NewPage.module.scss'
const ShlubDohovir = () => {
  return (
    <>
          <h2 className={css.title}>Необхідні документи:</h2>
          <p className={css.text}>
              паспорт (звертаємо Вашу увагу на наявність в паспорті вклеєних фотографій при досягненні особою 25-річного або 45-річного віку);
реєстраційний номер облікової картки платника податків;<br />
свідоцтво про реєстрацію шлюбу або документ, який підтверджує, що особи подали заяву про реєстрацію шлюбу.
          </p>     
    </>
  )
}

export default ShlubDohovir
